// frontend/src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({

    palette: {
        background: {
            default: '#282828', // Replace with your desired background color
        },
        text: {
          color: '#daddda',
        },
    // ... other palette options
    },
  components: {
    // Name of the component
    MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: '#282828',
          },
       },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#daddda', // Apply the text color globally
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'standard',
      },
    },
  },
});

export default theme;